import contentfulGql from 'js/lib/contentfulGql';

export const getAllExtraMetadataQuery = contentfulGql`#graphql
query AllExtraMetadata(
    $degreeSlugs: [UniversityProgramDegreeDescriptionPageFilter]
    $mastertrackSlugs: [PremiumCertificatePageContentFilter]
    $locale: String!
) {
  universityProgramDegreeDescriptionPageCollection(locale: $locale, where: { OR: $degreeSlugs }) {
    items {
      slug
      atAGlance {
        timeFrame
      }
    }
  }
  premiumCertificatePageContentCollection(locale: $locale, where: { OR: $mastertrackSlugs }) {
    items {
      slug
      atAGlance {
        timeFrame
      }
    }
  }
}
`;

export default getAllExtraMetadataQuery;
